<ngx-smart-modal
    #appEulaModal
    class="app-agreement-modal"
    [identifier]="modalType"
    [closable]="true"
    [title]="modalTitle"
    [showCloseButton]="true"
    [showConfirmButton]="showConfirmButton"
    [closeButtonText]="modalCloseButtonText"
    [confirmButtonText]="modalConfirmButtonText">
  <div class="agreement-content" [innerHTML]="modalContent"></div>
</ngx-smart-modal>
